import { Layout as AntLayout, Col, Row, Typography } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions } from './Layout.redux';
import LayoutNavigation from './LayoutNavigation';

const { Header, Footer, Content, Sider } = AntLayout;
const year = new Date().getFullYear();

const Layout = (props) => {
	const dispatch = useDispatch(),
		loggedIn = useSelector(state => state.auth.loggedIn),
		title = useSelector(state => state.layout.title),
		menuCollapsed = useSelector(state => state.layout.menuCollapsed),
		email = useSelector(state => state.auth.email),
		name = useSelector(state => state.auth.name);

	const [username, setUsername] = useState('');
	const [userEmail, setUserEmail] = useState('');

	useEffect(() => {
		// console.log('userDetail email change');
		// console.log(email)
		// NOTE from Cookies.get('TS_email')
		setUserEmail(email);
	}, [email]);

	useEffect(() => {
		// console.log('userDetail name change');
		// console.log(name)
		// NOTE from Cookies.get('TS_name')
		setUsername(name);
	}, [name]);


	useEffect(() => {
		if (window.screen.width < 768) {
			dispatch(actions.setState({ menuCollapsed: true }));
		}
	}, [dispatch]);

	const toggleShowMenu = () => dispatch(actions.setState({ menuCollapsed: !menuCollapsed }));

	return (
		<AntLayout>

			<Header className="ts_header">
				<Row>
					<Col>
						{
							(loggedIn && !menuCollapsed) && <MenuFoldOutlined className="ts_nav_collapse_icon" onClick={toggleShowMenu} />
						}
						{
							(loggedIn && menuCollapsed) && <MenuUnfoldOutlined className="ts_nav_collapse_icon" onClick={toggleShowMenu} />
						}
					</Col>
					<Col>
						<a href="/"><div className="header_logo" alt={import.meta.env.VITE_COMPANY_NAME} /></a>
					</Col>
					<Col className="ts_header_title_container">
						<Typography.Title level={2} className="ts_header_title">
							{title
							}
							{username ?
								' - ' + username + ' [' + userEmail + '] '
								: null
							}
						</Typography.Title>
					</Col>
				</Row>

			</Header>


			<AntLayout>
				{loggedIn &&
					<Sider trigger={null} collapsible collapsed={menuCollapsed} className="ts_sider_container">
						<LayoutNavigation />
					</Sider>
				}

				<div className="nonheader_wrapper">
					<Content className="ts_content">
						{props.children}
					</Content>

					<Footer className="ts_footer" align="center">
						&copy; {year} {import.meta.env.VITE_COMPANY_NAME}. All rights reserved. 
						<a href='https://www.gaumard.com/sales-term-conditions' target="_blank" rel="noopener noreferrer"> &nbsp;Terms and Conditions</a>
					</Footer>
				</div>
			</AntLayout>


		</AntLayout>
	);
};


export default Layout;
